import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';

// styles
import style from '../../Styles/Containers/Modal_Barcode.module.css'

// component
import Header from '../Header/header'

class ModalBarcodeComponent extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            this.props.visible ? <div className={style.mask} onClick={() =>  this.props.handleModal()}>
                <div className={style.modal}>
                    <div className={style.productWrapper}>
                        <div className={style.topImageArea}>
                            {this.props.topImage}
                        </div>
                        <div className={style.topContent}>{this.props.topContent}</div>
                        <div className={style.middleContent}>{this.props.middleContent}</div>
                    </div>
                    <div className={style.codeWrapper}>
                        <div className={style.bottomContent}>{this.props.bottomContent}</div>
                    </div>
                </div>
            </div>
            :
            null
        )
    }
}

export default connect()(withRouter(ModalBarcodeComponent))